export default {
  direction: 'ltr',

  home: {
    header: {
      selectLanguage: 'Language',
      contact: 'Contact',
      blog: 'Blog',
      atrvasa: 'Atrvasa'
    },
    main: {
      index:{
        bannerTitle: 'A Solution For Software Products',
        bannerDescription: 'Get easy way to creation and maintenance your products.',
        bannerFooter: 'You can use Atrvasa to:'
      },
      contact: {
        bannerTitle: 'Atrvasa (Amin Nouri)',
        bannerDescription: '',
        sendRequestName: 'Name',
        sendRequestPhone: 'Phone',
        sendRequestEmail: 'Email',
        sendRequestDesc: 'Description',
        sendRequestTitle: 'Send'
      }
    },
    footer: {
      dashboard: 'Dashboard',
      links: 'Links',
      github: 'GitHub'
    }
  },

  dashboard:{
    logoutTitle: 'Logout'
  },

  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clean'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      buttonTitle: 'Select your file',
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue',
      note: 'less than 500 kb'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      backButtonText: 'return'
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }
  },
  notify: {
    exceptionTitle: 'Exception',
    warningTitle: 'Warning'
  },

  taskList: {
    startTimeCaption: 'Incoming Time',
    loadedCaption: 'Incoming Time'
  },
  listStructure: {
    importDialogTitle: 'Import models from Json file',
    importButton: 'Import',
    selectFileForImport: 'Json File',
    exportDialogTitle: 'Export models to Json',
    exportButton: 'Convert',
    exportSetting:{
      removeIdTitle: 'Remove model ids'
    },
    searchPlaceHolder: 'words ...',
    actionCaption: 'Actions',
    emptyList: 'There is no rows',
    limitationNotSet: 'Limitation properties not set',
    confirmSetting: 'Ok',
    rejectSetting: 'Cancel',
    settingTitle: 'Setting',
    limitationTitle: 'Limitation',
    confirmLimitation: 'Limit',
    rejectLimitation: 'Cancel',
    methodSuccessTitle: 'This command done successfully.',
    pagination: {
      nextText: 'next',
      prevText: 'previous'
    }
  },

  validation: {
    completeFormMessage: 'Please Complete Information'
  },

  loginPage: {
    usernameValidation: {
      required: 'Please enter your username.'
    },
    passwordValidation: {
      required: 'Please enter password.'
    },
    header: 'Login Form',
    signUpHeader: 'Need to Signup?',
    username: 'Username',
    password: 'Password',
    language: 'Select your language',
    login: 'Login',
    signUp: 'Sign Up',
  },
  registerPage: {
    register: 'Register',
    phone: 'Phone'
  },

  page: {
    card: {
      viewDetail: 'more'
    }
  },

  model: {
    updateButtonText: 'Edit',
    deleteButtonText: 'Remove',
    rejectButtonText: 'Cancel',
    okButtonText: 'Ok',
    reservationMessageTitle: 'Reserve',
    successPersistTitle: 'Successfully Persist',
    deleteDialog: {
      title: 'Remove Warning',
      warningNote: 'Are you sure to remove model(s)?',
      confirm: 'Yes',
      cancel: 'No',
      successMessage: 'Successfully Removed',
      cancelMessage: 'Deletion Canceled'
    }
  },

  qasedak: {},

  permission: {
    editor: {
      isGrant: 'Granted',
      fullAccessText: 'Full Access',
      savePermissionText: 'Save',
      captionColumnText: 'Trustee',
      addPermissionDialogTitle: 'New Permission',
      addTrusteeDialogTitle: 'New Trustee',
      addPermissionButtonText: 'Add Permission',
      addTrusteeButtonText: 'Add Trustee',
      cancelButtonText: 'Cancel',
      searchPlaceHolder: 'Search',
    }
  },

  blog: {
    searchPanelText: 'Search',
    categoriesPanelText: 'Categories',
    morePostsText: 'More Posts ...'
  },
  post: {
    card:{
      readMore: 'Read More'
    },
    authorByText: 'By',
    emptyText: 'This content has no text',
    list:{
      columns:{
        title: 'Title',
        user: 'Author',
        category: 'Category',
        date: 'Date',
        commentQty: 'Comments',
      }
    },
    detail: {
      data: {
        title: 'Content Data',
        key: 'key',
        keyPlaceholder: 'Input Content key',
        categoryTitle: 'Category',
        bgColorTitle: 'Background Color',
        bgColorPlaceholder: 'Select background color',
        colorTitle: 'Pen Color',
        colorPlaceholder: 'Select Pen Color',
        tagsTitle: 'Tags',
        tagsPlaceholder: 'Select one or mode tags',
        thumbnailTitle: 'Thumbnail',
        imageTitle: 'Cover Image',
        seoTitle: 'SEO Title',
        seoTitlePlaceholder: 'Enter SEO title',
        seoDescriptionTitle: 'SEO description',
        seoDescriptionPlaceholder: 'Enter SEO description',
        seoKeywordsTitle: 'SEO Words',
        seoKeywordsPlaceholder: 'Enter SEO words',
      },
      generalTitle: 'General Information',
      titlePlaceholder: 'Title',
      textType: {
        marked: 'Marked',
        html: 'Html',
        text: 'Text',
      },
      markedContentPlaceholder: 'Enter content as a Marked language',
      htmlContentPlaceholder: 'Enter content as a HTML',
      textContentPlaceholder: 'Enter Text',
      summaryTitle: 'Summary',
      classificationTitle: 'Classification',
      summaryPlaceholder: 'Enter Summary',
      commentsTitle: 'Comments',
    },
    comment: {
      comments: 'Comments',
      addCommentTitle: 'Please Enter Your Opinion',
      sendButtonText: 'Send',
      resetButtonText: 'Clear',
      addSuccessMessage: 'Your opinion successfully added',
      rules: {
        name: {
          text: 'Name',
          requiredMessage: 'Enter your name',
          min_maxMessage: ''
        },
        phone: {
          text: 'Phone',
          requiredMessage: 'Enter your phone to get call'
        },
        email: {
          text: 'Email',
          requiredMessage: 'Enter your email to get response'
        },
        note: {
          text: 'Description',
          requiredMessage: 'Enter your opinion'
        }
      }
    }
  },

  menuEditor: {
    emptyTree: 'Empty',
    deleteButtonCaption: '',
    update: '',
    createNew: '',
  },

  actions: {
    cancel: 'Cancel',
    next: 'Next',
    ok: 'Ok'
  }
};
